import React from 'react';
import { Button, Tooltip, withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import MemoInfoIcon from '../../Icons/InfoIcon';

const useStyles = makeStyles(theme => ({
  linkInfo: {
    width: '100%',
    marginRight: '120px',
    textAlign: 'right',
    fontSize: 24,
  },
}));

const tooltipBorderColor = '#148192';
const UserRolesTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    fontSize: '1em',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: tooltipBorderColor,
    borderRadius: '4px',
    width: '770px',
    maxWidth: '770px',
    marginRight: '88px',
    height: '360px',
    maxHeight: '360px',
  },
  arrow: {
    color: theme.palette.common.white,
    '&:before': {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: tooltipBorderColor,
    },
  },
}))(Tooltip);

const LinkUserRolesTooltip: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'administration.users.create' });

  return (
    <div className={classes.linkInfo}>
      <UserRolesTooltip
        title={<img src="/tips-sortingcenter-userroles.png" alt={t('tooltipAlt')} width="750" />}
        placement="bottom"
        arrow
      >
        <Button>
          <MemoInfoIcon width={20} height={20} />
          &nbsp; {t('userRolesTooltip')}
        </Button>
      </UserRolesTooltip>
    </div>
  );
};

export default LinkUserRolesTooltip;
